import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericGet } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state';
import { API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_USER_NOTCOMPLETED_PATH_KEY } from '@/swagger/constants/surveys-keys';
import {
  API_GET_EMPLOYER_NOT_COMPLETED_SURVEYS,
  KEY_GET_EMPLOYER_NOT_COMPLETED_SURVEYS,
} from '../constats';
import { MOCK_RESPONSE_GET_EMPLOYER_NOT_COMPLETED_SURVEYS } from '../mocks';

type RequestGetEmployerNotCompletedSurveys = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_USER_NOTCOMPLETED_PATH_KEY
>['request']['path'];

type ResponseGetEmployerNotCompletedSurveys = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_USER_NOTCOMPLETED_PATH_KEY
>['response']['body'];

type CallParamsGetEmployerNotCompletedSurveys = Omit<
  RequestGetEmployerNotCompletedSurveys,
  'organizationId'
> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponseGetEmployerNotCompletedSurveys = ResponseGetEmployerNotCompletedSurveys;

type CallErrorGetEmployerNotCompletedSurveys = GenericApiError;

type CallSelectorsGetEmployerNotCompletedSurveys = {
  userHasSurveysToComplete: boolean;
};

export const getEmployerNotCompletedSurveysCall = createGeneralCall<
  CallParamsGetEmployerNotCompletedSurveys,
  CallResponseGetEmployerNotCompletedSurveys,
  CallErrorGetEmployerNotCompletedSurveys,
  CallSelectorsGetEmployerNotCompletedSurveys
>({
  id: KEY_GET_EMPLOYER_NOT_COMPLETED_SURVEYS,
  method: 'get',
  url: () => state => {
    const org = getCurrentOrganization(state);
    return API_GET_EMPLOYER_NOT_COMPLETED_SURVEYS(org);
  },
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_GET_EMPLOYER_NOT_COMPLETED_SURVEYS : undefined,
  selectors: {
    userHasSurveysToComplete: ({ selectors }) =>
      createSelector(selectors.response, res => res?.length > 0),
  },
});
